import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-page-size',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './page-size.component.html',
  styleUrl: './page-size.component.scss',
})
export class PageSizeComponent {
  defaultPageSizeOptions = [10, 25, 50];
  @Input({ required: true }) pageSize!: number;
  @Input() pageSizeOptions: number[] = this.defaultPageSizeOptions;
  @Input() selectId = 'pageSizeSelect';
  @Output() pageSizeChanged = new EventEmitter<number>();

  onPageSizeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const newPageSize = Number(selectElement.value);
    this.pageSizeChanged.emit(newPageSize);
  }
}
